import apiRequestService from '@/commonProject/service/apiRequestService';

export default class signupRepository {
    /**
     * 自己サインアップ事前チェックAPIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async sendSignUpCheckActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/signupchk', requestBody, idToken);
        return result;
    }

    /**
     * 自己サインアップ1APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async sendSignUp1ActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/signup1', requestBody, idToken);
        return result;
    }
    /**
     * 自己サインアップ2APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async sendSignUp2ActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/signup2', requestBody, idToken);
        return result;
    }
}
